import React, { Component } from 'react';
import LanguageUtil from '../../../../util/LanguageUtil';

class ConnectionUnkownComponent extends Component {
  render() {
    return (
      <div className={'flex flex-col w-full h-full items-center justify-center gap-y-4'}>
        <svg width='140' height='140' viewBox='0 0 140 140' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='70' cy='70' r='70' fill='#4F4F4F' fillOpacity='0.2' />
          <g filter='url(#filter0_d_233_6858)'>
            <circle cx='70' cy='70' r='50' fill='#4F4F4F' />
          </g>
          <path
            d='M70.6726 86.1538C71.4418 86.1538 72.1149 86.8269 72.1149 87.5961V90.673C72.1149 91.4423 71.4418 92.1153 70.6726 92.1153H67.5956C66.8264 92.1153 66.1533 91.4423 66.1533 90.673V87.5961C66.1533 86.8269 66.8264 86.1538 67.5956 86.1538H70.6726Z'
            fill='white'
          />
          <path
            d='M72.1153 78.75C72.1153 76.7308 73.3653 74.9038 75.0961 74.1346H75.1922C80.1922 72.1154 83.6538 67.2115 83.6538 61.4423C83.6538 53.9423 77.4999 47.7885 69.9999 47.7885C63.0768 47.7885 57.3076 52.8846 56.3461 59.5192V59.6154C56.2499 60.4808 56.923 61.1538 57.7884 61.1538H60.8653C61.6345 61.1538 62.2115 60.6731 62.3076 60.0961V59.9038C62.9807 56.3461 66.1538 53.6538 69.9038 53.6538C74.2307 53.6538 77.6922 57.1154 77.6922 61.4423C77.6922 63.4615 76.923 65.2885 75.673 66.7308L75.5768 66.8269C74.7115 67.7885 73.5576 68.3654 72.4038 68.75C68.5576 70.0961 65.9615 73.75 65.9615 77.7885V79.2308C65.9615 80 66.5384 80.5769 67.3076 80.5769H70.3845C71.1538 80.5769 71.923 80 71.923 79.1346L72.1153 78.75Z'
            fill='white'
          />
          <defs>
            <filter id='filter0_d_233_6858' x='11' y='11' width='120' height='120' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
              <feFlood floodOpacity='0' result='BackgroundImageFix' />
              <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
              <feOffset dx='1' dy='1' />
              <feGaussianBlur stdDeviation='5' />
              <feComposite in2='hardAlpha' operator='out' />
              <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
              <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_233_6858' />
              <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_233_6858' result='shape' />
            </filter>
          </defs>
        </svg>

        <p>{LanguageUtil.get({ id: 'pages.connection.editor.connectionStatus.title', defaultMessage: 'Connection Status' })}</p>
        <p className={'text-[#828282]'}>
          <p>{LanguageUtil.get({ id: 'pages.connection.editor.connectionStatus.unknown', defaultMessage: 'Unknown' })}</p>
        </p>
        <div
          className={
            'px-5  py-5 bg-gradient-to-r from-f-gray to-[#FDFDFD] mt-5 rounded shadow-sm flex flex-col items-center justify-center w-5/6 text-primary text-md'
          }
        >
          <p>{LanguageUtil.get({ id: 'pages.connection.editor.connectionStatus.unknownDesc', defaultMessage: 'Connection has not been tested yet.' })}</p>
          <p>
            {LanguageUtil.get({
              id: 'pages.connection.editor.connectionStatus.unknownDesc2',
              defaultMessage: 'Please click on test button to check connection.',
            })}
          </p>
        </div>
      </div>
    );
  }
}

export default ConnectionUnkownComponent;
